import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiAnalyticsPlansKpiTermsIndexResponseType,
  ApiAnalyticsPlansKpiTermsIndexRequestType,
} from "~/domains";

type RequestDataType = {
  params?: ApiAnalyticsPlansKpiTermsIndexRequestType;
};

const request = async ({
  params,
}: RequestDataType): Promise<ApiAnalyticsPlansKpiTermsIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiAnalyticsPlansKpiTermsIndexResponseType>(
      "/api/analytics_plans/kpi_terms",
      params,
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  params?: ApiAnalyticsPlansKpiTermsIndexRequestType;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisAnalyticsPlansKpiTermsIndex = ({
  params,
  config = {},
}: PropsType = {}): UseQueryResult<ApiAnalyticsPlansKpiTermsIndexResponseType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ["ApisAnalyticsPlansKpiTermsIndex", params],
    queryFn: () => request({ params }),
  });
};
